import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllContractTypes = () => {
    return axiosInstance({
        url: config.routes.contractTypes,
        method: 'get',
    });
};

export const addContractType = (name, id) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: id !== null ? config.routes.updateContractType(id) : config.routes.addContractType,
        method: id !== null ? 'put' : 'post',
        headers: {
            "Authorization": `Bearer ${token}`
        },
        data: {
            "name": name
        }
    });
};

export const fetchContractTypeDetails = (id) => {
    return axiosInstance({
        url: config.routes.updateContractType(id),
        method: 'get'
    });
};

export const deleteContractType = (id) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.updateContractType(id),
        method: 'delete',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
};